import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesSupportComponent } from './sales-support.component';

const routes: Routes = [
  { path: '', component: SalesSupportComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesSupportRoutingModule {}
